import { useState, useEffect } from 'react';
import { getCurrentLanguage, t, type Language } from '@/app/utils/i18n';

/**
 * Custom hook for translations
 * Usage: const { t, lang } = useTranslation();
 */
export function useTranslation() {
  const [lang, setLang] = useState<Language>(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = (e: CustomEvent) => {
      setLang(e.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange as EventListener);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange as EventListener);
    };
  }, []);

  const translate = (category: Parameters<typeof t>[0], key: string, params?: Record<string, unknown>) => {
    return t(category, key, lang, params);
  };

  return { t: translate, lang };
}
